import React from 'react';
import Pages from './Pages.js';
import { HardwareRef } from '../components/HardwareRef.js'
// import BarLoader from 'react-spinners/ClipLoader';
// import { CSSRef } from '../components/CSSRef';

class Hardware extends Pages {
  componentDidMount() {
    window.scrollTo(0, 0)
    // setTimeout(function () {
    //   this.setState({ isLoading: false });
    // }.bind(this), 5000);
  }

  leftmenu = () => {
    return (
      <div className='leftmenu'>
        <div>
          Hardware
        </div>
        <br />
        <button onClick={() => this.scroll(this.firstRef)} className={'section'}> Overview </button>
        <button onClick={() => this.scroll(this.secondRef)} className={'section'}> Initial Consideration of Bioreactor Design </button>
        <button onClick={() => this.scroll(this.secondRef)} className={'subsection'}> Granular environmental control </button>
        <button onClick={() => this.scroll(this.thirdRef)} className={'subsection'}> Temperature Control</button>
        <button onClick={() => this.scroll(this.sixthRef)} className={'subsection'}> pH Control</button>
        <button onClick={() => this.scroll(this.seventhRef)} className={'subsection'}> Carbon Dioxide Control</button>
        <button onClick={() => this.scroll(this.eighthRef)} className={'subsection'}> Salinity Control</button>

        <button onClick={() => this.scroll(this.ninthRef)} className={'section'}> Bioreactor Design </button>
        <button onClick={() => this.scroll(this.tenthRef)} className={'subsection'}> Components</button>
        <button onClick={() => this.scroll(this.eleventhRef)} className={'subsection'}> Implementation </button>

        <button onClick={() => this.scroll(this.refRef)} className={'section'}> References</button>


      </div>
    )
  }
  righttext = () => {
    return (
      <div className='righttext'>
        <h1 ref={this.firstRef}>Overview</h1>
        <p>
          <br /><br />
          The basis of our idea is derived from the experience we have in cultivating and maintaining microalgae for research. Since microalgae require a large amount of care in cultivation due to the necessity to control several environmental factors such as salinity, pH, temperature, and illumination. The need to optimize for a multitude of factors leads to eventual inefficiencies that arise in the lack of resources, equipment or space. To tackle this, we conceptualized an idealized and favorable chamber for microalgae cultivation. This bioreactor can be used for both cultivation and maintenance of cultures for research purposes or for the production of microalgal feed.
        </p>
        <br />
        <h1 ref={this.secondRef}>Initial Consideration of Bioreactor Design</h1><br />
        To optimize the varying conditions in the growth of microalgae, all these conditions need to be accounted for, measured and controlled.
        <br /><br />
        <h2 >Granular environmental control</h2>
        <p>
          <br />
          Our design relies on red LEDs to provide illumination for microalgae to grow which can optimize the growth of microalgae (Archana et al., 2018). The chamber is evenly illuminated with granular control, this allows us to incorporate day/night cycles and adjust appropriate illumination for cultivation, bioreactor growth or even different species. Pumps are used to control flow of media and waste into and out of the bioreactor. This allows us to maintain the flow of fresh media whilst removing waste or product, since the product is secreted into the media by flushing the system we are able to easily harvest and purify any protein product for our Phase I design.
        </p>
        <br />

        <h2 ref={this.thirdRef}>Temperature Control</h2>
        <p>
          <br />In order to maximize the growth of <i>Chlorella autotrophica</i>, cultivation at 25℃ is most optimal(Cho et. al., 2007).  A temperature sensor is used in the bioreactor to modulate the temperature of the medium. When the temperature fluctuates beyond the expected parameter, the temperature sensor will give an audible warning. A heating element is inserted into the tank, connected to the sensor to accurately modulate and maintain the temperature of the medium.<br /><br />
          However, since a cooling element would be expensive and complicated to set up if the reactor were to increase in temperature exceedingly. A vacuum layer is added to prevent heat transfer via radiation, further the stirring blade can also be controlled to induce a mild cooling effect in the bioreactor.
        </p>
        <br />
        <h2 ref={this.sixthRef}>pH Control</h2>
        <p>
          <br />
          Since pH is a factor to be heavily regulated, as <i>Chlorella</i> exhibits differential growth at varying pH, the control of pH within the medium is key to maintaining a successful culture. <i>Chlorella</i> is typically grown between 6.5 to 7 pH (Wang et al., 2010), a pH probe is inserted to monitor the pH value. Based upon the reading from this probe, hydrochloric acid will be added automatically if the pH is too high, and ammonium chloride will be added if the pH is too low.
        </p>
        <br />
        <h2 ref={this.seventhRef}>Carbon Dioxide Control</h2>
        <p>
          <br />
          Whilst carbon dioxide is typically not a concern in smaller laboratory-scale cultures, the need to carbon dioxide injection to maximize growth and productivity typically scales with the size of the culture and thus bioreactor. Including a carbon dioxide tank to a variable valve connected to a diffuser in the tank will allow for even carbonation of the media, maximizing the efficiency of photosynthesis and productivity. Further to aid in the even dissolution of carbon dioxide, a stirring blade is used to further increase efficiency of gaseous exchange in the microalgae.
        </p>
        <br />
        <h2 ref={this.eighthRef}>Salinity Control</h2>
        <p>
          <br />
          Depending on the species of microalgae grown, there may be an extremely wide range of salinity required between species. For example the growth of <i>Chlorella</i> is optimum at 10% salinity.(Haris et al., 2022). Maintaining the correct salinity will be carried out via the use of a probe inserted to measure salinity continually. To balance salinity if necessary, concentrated saline solution will be used to increase salinity whereas Milli Q water will be used to decrease salinity.
        </p>
        {/* Bioreactor Design */}
        <br />
        <h1 ref={this.ninthRef}>Bioreactor Design</h1>
        <div style={{ textAlign: 'center' }}>
          <img src={'https://static.igem.wiki/teams/4241/wiki/hardware/photo-for-hardware-writes-up.jpeg'} alt='' className='page-img' style={{ width: '80%', height: 'auto' }} />
          <br />Figure 1. Bioreactor Design<br />
        </div>
        <br />
        <h2 ref={this.tenthRef}>Components</h2>
        <p>
          <br />
          Figure 1 shows the components of the bioreactor design.
          <br />
          Pipes: For the flow of influent and effluent flow of medium.
          <br />
          Pumps: To control the influent and effluent flow of the medium.
          <br />
          Motor: To rotate the stirring blade
          <br />
          Stirring blade: To mix the substances inside the bioreactor evenly.
          <br />
          Red LED: To supply light energy for cultivation.
          <br />
          Inner container: To hold the medium and it is transparent to allow light energy enter the medium.
          <br />
          Outer container with vacuum layer: To locate the red LED and provide an enclosed environment for cultivation.
          <br />
          Heater probe: To control the temperature of the medium
          <br />
          Sensor probe: To monitor temperature, pH value and salinity

        </p>
        <br />
        <h2 ref={this.eleventhRef}>Implementation</h2>
        <p>
          <br />
          Our device is designed for small to medium-scale microalgae cultivation. Due to its environmental monitoring system it is very capable of cultivating a large variety of microalgae in laboratories, with constant effluent and affluent control, secreted products from transgenic algae will easily be collected, harvested and purified such as that in AMPed Phase I.  WIth some simple adjustments to increase ease of use, this can also be used in industrial settings to larger scale cultivation purposes such as that in algal based feed and supplements such as that in AMPed Phase II.
        </p>
        <br />

        {this.reference(HardwareRef)}

      </div>


    )
  }

  render() {
    return (
      <>
      
        {/* {this.state.isLoading ? <div className='load-container'><BarLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={CSSRef} /></div> : null} */}
        <h1 className='des'>
          Hardware
          {/* Consideration for AMPed feeding design */}
        </h1>
        <div className='pageholder'>
          {this.leftmenu()}
          {this.righttext()}
        </div>
      </>
    );
  }
}


export default Hardware;
